import React, { memo, useCallback, useEffect, useRef, useState } from 'react'

import i18n from '@batical/i18n'
import { useContextValue } from '@batical/reducer/src'
import { CalculCodeStateKeys } from '@batical/types/src'
import { InputAdornment } from '@mui/material'

import { ViewLine, CalculText, CalculTextInput } from './LineStyleComponent'
import { textColor } from '../Colors'
import { textFont } from '../Fonts'
import { textBasicSize } from '../Metrics'
import { Text } from '../Native/Text'

const isDouble = (value: unknown) => {
  return typeof value === 'number' || value instanceof Number
}
export type TempExtBaseLineProps = {
  unit?: string
  calculCode: CalculCodeStateKeys
  variableName: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  icon: any

  onChange?: (number: number, value: string) => void

  /**
   * if true, the line is the first of a group
   *
   * @type {boolean}
   */
  first?: boolean
  /**
   * if true, the line is the last of a group
   *
   * @type {boolean}
   */
  last?: boolean
  /**
   * If true, the calcul will be done
   *
   * @type {boolean}
   */
  doCalcul?: boolean
}

const TempExtBaseLine = ({ calculCode, variableName, unit, onChange, first, last, doCalcul = false }: TempExtBaseLineProps) => {
  const [value, update] = useContextValue(variableName, calculCode, doCalcul)

  const textInputRef = useRef(null)
  const [inputVal, setInputVal] = useState('0')

  useEffect(() => {
    if (isDouble(value)) {
      setInputVal(String(+value))
    }
  }, [value])

  const _onEndEditing = useCallback(() => {
    const result = parseFloat(inputVal.replace(',', '.'))
    if (isNaN(result)) {
      setInputVal(String(+value))

      if (onChange) {
        onChange(0, variableName)
      } else {
        update(0)
      }
    } else if (String(value) === inputVal) {
      // console.error('textinputline, I donw now why this condition but should not happen')
      // i saw it happen so it is required but did not analyse why
      if (onChange) {
        onChange(value, variableName)
      } else {
        update(value)
      }

      setInputVal(inputVal)
    } else {
      if (onChange) {
        onChange(result, variableName)
      } else {
        update(result)
      }
    }
  }, [inputVal, onChange, update, value, variableName])

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const _onChangeText = useCallback((event: any) => {
    setInputVal(event.target.value)
  }, [])

  const onFocus = useCallback(() => {
    setInputVal('')
  }, [])

  // const _onTouchCell = useCallback(() => {
  //   if (onDisclosurePress != null) {
  //     let val = 0 || parseFloat(inputVal.replace(',', '.'))
  //     // if (value != null) {
  //     onDisclosurePress(val, extraParam)
  //     //  }
  //   } else {
  //     //textInputRef?.current?.focus()
  //   }
  // }, [extraParam, inputVal, onDisclosurePress])
  const onKeypress = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e: any) => {
      if (e.key === 'Enter') {
        _onEndEditing()
      }
    },
    [_onEndEditing]
  )

  return (
    <ViewLine first={first} last={last}>
      <CalculText>{i18n.t(`${calculCode}_${variableName}`)}</CalculText>

      <CalculTextInput
        ref={textInputRef}
        value={inputVal}
        onFocus={onFocus}
        onChange={_onChangeText}
        onKeyPress={onKeypress}
        onBlur={_onEndEditing}
        variant="outlined"
        size="small"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end" sx={{ color: textColor, fontSize: textBasicSize, fontFamily: textFont }}>
              <Text>{unit}</Text>
            </InputAdornment>
          )
        }}
      />
    </ViewLine>
  )
}

export default memo(TempExtBaseLine)
